import React, {useEffect, useRef, useState} from "react"
import DOMPurify from 'dompurify';
import ChaiMarked from "../../../classes/ChaiMarked";
const marked = new ChaiMarked().marked

function Chatbox({ messages, btnIsDisabled, askQuestion, adviceId }) {
    const [ question, setQuestion ] = useState("")
    const copyToClipboardRef = useRef(null)
    const msgContainerRef = useRef(null)
    const sendMessage = () => {
        if(!question.length) return
        askQuestion(question)
        setQuestion("")
    }
    const copyMessage = async (message) => {
        window.copyToClipboard(message)
        copyToClipboardRef.current.classList.add("pop")
        setTimeout(() => {
            copyToClipboardRef.current.classList.remove("pop")
        }, 300)
    }
    const scrollToLastMessage = () => {
        const {scrollHeight, clientHeight} = msgContainerRef.current
        const messages = document.querySelectorAll(`#chat-${adviceId} .message`)
        if(scrollHeight > clientHeight) {
            messages[messages.length-1].scrollIntoView(true)
            const inputs = document.querySelector(`#chat-${adviceId} .chat-inputs`)
            inputs.scrollIntoView(false)
        }
    }
    useEffect(() => {
        scrollToLastMessage()
    }, [messages])
    return <div id={`chat-${adviceId}`} className="chatbox">
        <div className="messages-container" ref={msgContainerRef}>
            {messages.length ? messages.map((message, i) => {
                let sanitizedHtml;
                if(message.from === "chai") {
                    const html = marked.parse(message.text)
                    sanitizedHtml = DOMPurify.sanitize(html, { ALLOWED_ATTR: ["target", "href", "rel", "class"] })
                }
                return message.from === "chai" ? <div key={`chai-${i}-${message.date}`} className={`message message-shadow ${message.from}-message`}>
                    <div className={` `}>
                        <div className="" dangerouslySetInnerHTML={{__html: sanitizedHtml}}></div>
                    </div>
                    {message.done ? <div className="message-actions">
                        <i ref={copyToClipboardRef} class="action copy-action fa-regular fa-copy" onClick={(e) => copyMessage(message.text)}></i>
                    </div>
                    : null}
                </div>: 
                   <div key={`user-${i}-${message.date}`} className={`message ${message.from} mt-3 mb-3`}><span>{message.text}</span></div>
            }): <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
          </div>}
        </div>
        <div className="chat-inputs">
            <input type="text" className="" placeholder="Message for AI assistant" value={question} onKeyDown={(e) => e.key === "Enter" && sendMessage()} onChange={(e) => setQuestion(e.target.value)}></input>
            <button className="" disabled={btnIsDisabled} onClick={sendMessage}>Send</button>
        </div>
    </div>
}

export default Chatbox